<template>
  <div class="flex items-center justify-between w-full ellevio-desktop-nav-upper">
    <a :href="logoLink" class="flex items-center my-3 rounded-sm" data-testid="desktopMenuLogoLink">
      <img class="inline ellevio-logo" :src="`${isDevelopment ? '' : '/gui-web'}/img/logo-orange.svg`" :alt="navigationData.translations?.altTexts?.logotypeAltText" data-testid="desktopMenuLogoImage" />
    </a>
    <div class="flex items-center">
      <nav :aria-label="navigationData.translations?.ariaLabels?.upperNav">
        <ul class="flex gap-5" role="menu">
          <li v-for="(item, index) in navigationData.secondaryMenu" :key="`desktopNavUpper-${index}`">
            <a :href="item.url" :target="item.target === '' ? '_self' : item.target" class="text-lg rounded-sm animated-menu-link" :class="item.isSelected && !megaMenuOpen ? 'active' : ''" role="menuitem" :data-testid="`desktopMenuUpperNavLink-${index}`">{{
              item.text
            }}</a>
          </li>
          <li v-if="otherLanguage?.url" class="flex items-center">
            <a :href="otherLanguage?.url" class="flex items-center rounded-sm ellevio-lang-switch" :aria-label="navigationData.translations?.ariaLabels?.changeLanguage" role="menuitem" data-testid="desktopMenuUpperNavLangSwitch">
              <span class="pl-1 mt-[3px] text-xs text-newColors-gray-content font-futuraEfDemiBold">{{ otherLanguage?.label }}</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ellevio-web-desktop-nav-upper',
  props: {
    navigationData: {
      type: Object,
      default: () => {}
    },
    otherLanguage: {
      type: Object,
      default: () => {}
    },
    logoLink: {
      type: String,
      default: '/'
    },
    megaMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDevelopment() {
      let env = {}
      try {
        env = import.meta.env
        if (typeof env !== 'object') env = {}
      } catch (_) {
        env = {}
      }
      return env.MODE === 'development'
    }
  }
}
</script>

<style scoped>
.ellevio-desktop-nav-upper {
  position: relative;
}
/* Gray divider */
.ellevio-desktop-nav-upper::after {
  @apply content-[''] bg-newColors-gray-baseB h-[1px] absolute left-0 bottom-[-1px];
  width: 100%;
}

.ellevio-logo {
  width: 7.5rem;
}

.ellevio-desktop-nav-upper:deep(a:focus) {
  outline: 2px dotted black;
  outline-offset: 4px;
}

.ellevio-desktop-nav-upper:deep(a.animated-menu-link:before) {
  bottom: -0.9rem;
  z-index: 1;
}
</style>
